import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ArticleBundleItem from "../article-bundle-item";
import { fetchCollection } from "../../../api";
import styles from "./styles.m.css";

const SpecialBundleCard = ({ className = "" }) => {
  const collectionSlug = "vikatan-series-bundle";
  const pageNumber = 0;
  const limit = 5;
  const [collections, setData] = useState([]);
  useEffect(() => {
    fetchCollection(collectionSlug, pageNumber, limit, {}, "collection").then(response => setData(response["items"]));
  }, []);
  return (
    <div className={`${styles["base"]} ${className}`}>
      <h2>விகடன் இப்போது…</h2>
      {collections && (
        <div className={styles["collections-wrap"]}>
          {collections.map(
            collection =>
              collection && (
                <ArticleBundleItem key={collection.id} collection={collection} className={styles["collection-item"]} />
              )
          )}
        </div>
      )}
    </div>
  );
};

SpecialBundleCard.propTypes = {
  className: PropTypes.string
};

export default SpecialBundleCard;
